var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamiconsBulbSharp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7568_19340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 15.1421H9.50001V16.1421H6.50001V15.1421ZM6.00001 13.6421H10V14.6421H6.00001V13.6421ZM11.5444 2.60117C10.6047 1.66023 9.34595 1.1421 8.00001 1.1421C7.34297 1.14054 6.69208 1.2688 6.08475 1.51952C5.47741 1.77024 4.92559 2.13847 4.46099 2.60308C3.99638 3.06768 3.62815 3.6195 3.37743 4.22684C3.12671 4.83417 2.99845 5.48506 3.00001 6.1421C3.00001 7.59898 3.55845 8.96179 4.53126 9.88085L4.66751 10.0087C5.23033 10.5349 6.00001 11.2559 6.00001 11.8921V13.1421H7.50001V9.05179L6.11626 8.2671L6.68751 7.44585L8.00001 8.1421L9.29033 7.44242L9.8872 8.24492L8.50001 9.05742V13.1421H10V11.8921C10 11.2709 10.7613 10.5505 11.3172 10.0243L11.4706 9.87867C12.4713 8.92335 13 7.62992 13 6.1421C13.0033 5.48499 12.8764 4.83374 12.6265 4.22597C12.3767 3.6182 12.0089 3.06596 11.5444 2.60117Z",
    fill: "#1F874C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7568_19340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.64209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiconsBulbSharp);
export default __webpack_public_path__ + "static/media/famicons_bulb-sharp.03315018b4658cef3001de5b0583568f.svg";
export { ForwardRef as ReactComponent };